import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Checkbox } from '../../ui/checkbox';
import { UploadInput } from '../../UploadInput';
import { BANKING_CHECKLIST } from '../../../utils/bankConstants';

const UpiQrSection = ({ bankForm, updateForm }) => {
  return (
    <div className="space-y-4 p-4 bg-white border rounded-lg">
      <h3 className="font-semibold text-sm text-slate-700">UPI & QR Code</h3>
      <div>
        <Label>UPI ID</Label>
        <Input value={bankForm.upi} onChange={(e) => updateForm('upi', e.target.value)} />
      </div>
      <div>
        <Label>QR Available</Label>
        <Select value={bankForm.qrAvailable} onValueChange={(val) => updateForm('qrAvailable', val)}>
          <SelectTrigger><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="yes">Yes</SelectItem>
            <SelectItem value="no">No</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label>Upload QR Code</Label>
        <UploadInput onUpload={(base64) => updateForm('qrDataUrl', base64)} />
      </div>
      <div className="mt-4 pt-4 border-t">
        <h3 className="font-semibold text-sm text-slate-700 mb-3">Banking App Availability</h3>
        <div className="space-y-3">
          {BANKING_CHECKLIST.map(item => (
            <div key={item.key} className="flex items-center gap-2">
              <Checkbox
                id={`add-${item.key}`}
                checked={bankForm[item.key]}
                onCheckedChange={(checked) => updateForm(item.key, !!checked)}
                data-testid={`add-${item.key}`}
              />
              <label htmlFor={`add-${item.key}`} className="text-sm cursor-pointer">{item.label}</label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UpiQrSection;
